module.exports = __webpack_public_path__ + "static/media/Lato-Bold.d878b6c2.woff";